import { FC } from 'react';

interface ProgressBarProps {
	currentStep: number; // 0 = ShoppingPreference, 1 = BrandSelection, ...
	stepLabels: string[];
}

const ProgressBar: FC<ProgressBarProps> = ({ currentStep, stepLabels }) => {
	return (
		<div className="pop-w-full pop-flex pop-flex-col pop-gap-1 pop-px-2 pop-my-4">
			{/* Horizontal Lines */}
			<div className="pop-w-full pop-flex pop-items-center pop-gap-2 pop-h-10">
				{stepLabels.map((_, index) => {
					let barColor = 'pop-bg-popsizeNeutral20';
					if (index < currentStep) barColor = 'pop-bg-popsizePrimary90';
					else if (index === currentStep) barColor = 'pop-bg-popsizeSecondary90';
                    console.debug(`Bar ${index}: class =`, barColor, '| currentStep =', currentStep);

					return (
						<div
							key={index}
							className={`pop-h-2 pop-flex-1 ${barColor}`}
						/>
					);
				})}
			</div>

			{/* Labels */}
			<div className="pop-w-full pop-flex pop-justify-between pop-text-xs pop-text-popsizeNeutral50 pop-pt-1 pop-gap-2">
				{stepLabels.map((label, index) => (
					<div key={index} className="pop-flex-1 pop-truncate pop-text-left pop-text-xs">
						{label}
					</div>
				))}
			</div>
		</div>
	);
};

export default ProgressBar;
